import theme from "@/common/styles/theme";
import { CSSProperties } from "react";

export const styles: { [key: string]: CSSProperties } = {
  droppableBox: {
    width: "250px",
    backgroundColor: "#f0f0f0",
    padding: "10px",
    height: "100%",
    maxHeight: "100vh",
  },
  droggableDiv: {
    backgroundColor: theme.palette.secondary.main,
    color: "#fff",
    margin: "5px 0",
    padding: "10px",
    borderRadius: "5px",
    cursor: "move",
  },
};
